__turbopack_context__.v({
  "quoteBlock": "_0fX6oG_quoteBlock",
  "quoteChange": "_0fX6oG_quoteChange",
  "quoteData": "_0fX6oG_quoteData",
  "quoteName": "_0fX6oG_quoteName",
  "quotePrice": "_0fX6oG_quotePrice",
});
